import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_LIVECLASSSCHEDULE,
  GET_LIVECLASSSCHEDULES,
  GET_LIVECLASSSCHEDULES_BY_FILTER,
  GET_LIVECLASSSCHEDULES_BY_FILTER_FOR_TABLE,
  GET_LIVECLASSSCHEDULES_CURRENT_ACADEMIC_PERIOD_BY_CODE_OR_NAME,
  ADD_LIVECLASSSCHEDULE,
  ADD_LIVECLASSSCHEDULES_UPLOAD,
  UPDATE_LIVECLASSSCHEDULE,
  DELETE_LIVECLASSSCHEDULE,
  GET_LIVE_CLASS_SCHEDULES_PAGINATION,
} from '@/queries/modules/live-class/live-class-schedule.js';

export async function getLiveClassSchedules(context) {

  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_LIVECLASSSCHEDULES,
        fetchPolicy: 'network-only'
      });
    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setLiveClassSchedules', data.getLiveClassSchedules);
      context.commit('setSuccess', null);
      return data.getLiveClassSchedules
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getLiveClassSchedulesByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_LIVECLASSSCHEDULES_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setLiveClassSchedules', data.getLiveClassSchedulesByFilter);
      context.commit('setSuccess', null);

      return data.getLiveClassSchedulesByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getLiveClassSchedulesByFilterForTable(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_LIVECLASSSCHEDULES_BY_FILTER_FOR_TABLE,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setLiveClassSchedules', data.getLiveClassSchedulesByFilter);
      context.commit('setSuccess', null);

      return data.getLiveClassSchedulesByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getLiveClassSchedulesCurrentAcademicPeriodByCodeOrName(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_LIVECLASSSCHEDULES_CURRENT_ACADEMIC_PERIOD_BY_CODE_OR_NAME,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);

      return data.getLiveClassSchedulesCurrentAcademicPeriodByCodeOrName;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getLiveClassSchedule(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_LIVECLASSSCHEDULE,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setLiveClassSchedule', data.getLiveClassSchedule);
      context.commit('setSuccess', null);
      return data.getLiveClassSchedule
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getLiveClassSchedulesPagination(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_LIVE_CLASS_SCHEDULES_PAGINATION,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);

      return data.liveClassSchedulesPagination;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function addLiveClassSchedule(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_LIVECLASSSCHEDULE,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const liveClassSchedules = [...context.state.liveClassSchedules];
      liveClassSchedules.push(data.addLiveClassSchedule);
      context.commit('setLiveClassSchedules', liveClassSchedules);
      context.commit('setSuccess', newItemSuccess(data.addLiveClassSchedule.topicLocal));

      return data.addLiveClassSchedule;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addLiveClassSchedulesUpload(context, payload) {
  context.commit('setProcessing', true);
  try {

    const result = await apolloClient
      .mutate({
        mutation: ADD_LIVECLASSSCHEDULES_UPLOAD,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', updateItemSuccess(data.addLiveClassSchedulesUpload.length));

      return data.addLiveClassSchedulesUpload
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateLiveClassSchedule(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_LIVECLASSSCHEDULE,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.liveClassSchedules.findIndex(item => item.id === data.updateLiveClassSchedule.id);
      const liveClassSchedules = [
        ...context.state.liveClassSchedules.slice(0, index),
        data.updateLiveClassSchedule,
        ...context.state.liveClassSchedules.slice(index + 1)
      ];
      context.commit('setLiveClassSchedules', liveClassSchedules);
      context.commit('setSuccess', updateItemSuccess(data.updateLiveClassSchedule.topicLocal));

      return data.updateLiveClassSchedule
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteLiveClassSchedule(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_LIVECLASSSCHEDULE,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.liveClassSchedules.findIndex(item => item.id === data.deleteLiveClassSchedule.id);
      const liveClassSchedules = [
        ...context.state.liveClassSchedules.slice(0, index),
        ...context.state.liveClassSchedules.slice(index + 1)
      ];
      context.commit('setLiveClassSchedules', liveClassSchedules);
      context.commit('setSuccess', deleteItemSuccess(data.deleteLiveClassSchedule.topicLocal));

      return data.deleteLiveClassSchedule
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

